// extracted by mini-css-extract-plugin
export default {"modal":"NewBankAccount_modal__n1lKT"};